export default __webpack_public_path__ + "static/media/ChildrenCamp.c63ba4ff.jpg";